import {DataLoader, LoadingSpinner} from '@wallaby-ui/core';
import classNames from 'classnames';
import React from 'react';

import {useLoadNumberRange} from '../hooks';

interface OwnProps extends DataLoader {}
type Props = OwnProps;

export const NumberRangeLoader: React.FC<Props> = (props) => {
  const {apiUrl, children} = props;

  const {isLoading} = useLoadNumberRange(apiUrl);

  if (isLoading) {
    return (
      <div
        className={classNames(
          'dlLoadingSpinnerContainer',
          'dlFlexBoxContainerInContainer',
          {dlLoadingSpinnerParent: true}
        )}
        style={{width: '100vw', height: '100vh'}}
        data-name={'loadingSpinnerParent'}
      >
        <LoadingSpinner isVisible />
      </div>
    );
  }
  return <>{children}</>;
};

NumberRangeLoader.displayName = 'NumberRangeLoader';
